import { render, staticRenderFns } from "./SetupWizardTab.vue?vue&type=template&id=5a82e02c&"
import script from "./SetupWizardTab.vue?vue&type=script&lang=js&"
export * from "./SetupWizardTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports